import React, { useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { Card, CardBody } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import { getTotalPaymentsAmount } from "common/services/payments.service";
import { Link, useParams } from "react-router-dom";
import CardWidgetSkeleton from "Components/Common/CardWidgetSkeleton";
import { CurrencyFormat, formatCurrencySuffix } from "common/lib/currency";
import PaymentsModal from "pages/Payments/PaymentsModal";

const TotalActiveSupport = () => {
  const { id: mdaId } = useParams();
  const [loading, setLoading] = useState(false);
  const [totalActiveSupport, setTotalActiveSupport] = useState<CurrencyFormat>({
    amount: 0,
    suffix: "",
    formattedString: "",
    exactAmount: 0,
  });
  const [totalSupport, setTotalSupport] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getTotalPaymentsAmount({
          mdaId,
        });
        setTotalSupport(response?.totalAmount);
      } catch (error) {
        console.warn("Error fetching total active support", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [mdaId]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getTotalPaymentsAmount({
          mdaId,
          active: true,
        });
        const formattedCurrency = formatCurrencySuffix(response?.totalAmount);
        setTotalActiveSupport(formattedCurrency);
      } catch (error) {
        console.warn("Error fetching total active support", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [mdaId]);

  const percentageValue = useMemo(() => {
    if (totalSupport === 0) return 0;
    return (totalActiveSupport?.exactAmount / totalSupport) * 100;
  }, [totalActiveSupport, totalSupport]);
  const toggleModal = (e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
    }
    setIsModalOpen(!isModalOpen);
  };

  const filter = {
    mda: {
      value: mdaId,
      label: "",
    },
    status: "active",
  };

  if (loading) {
    return <CardWidgetSkeleton />;
  }

  return (
    <Link to={`#`} onClick={toggleModal}>
      <Card className="card-animate">
        <CardBody>
          <div className="d-flex justify-content-between">
            <div>
              <p className="fw-medium text-muted mb-0">Total Active Support</p>
              <h2 className="mt-4 ff-secondary cfs-22 fw-semibold">
                <span className="counter-value">
                  <CountUp
                    start={0}
                    end={totalActiveSupport?.amount}
                    decimals={1}
                    duration={4}
                  />
                </span>
                {totalActiveSupport?.suffix}
              </h2>
              <p className="mb-0 text-muted text-truncate">
                <span className="badge bg-light text-success mb-0 me-2">
                  {percentageValue.toFixed(2)}%
                </span>
                of total support
              </p>
            </div>
            <div>
              <div className="avatar-sm flex-shrink-0">
                <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                  <FeatherIcon icon="dollar-sign" className="text-success" />
                </span>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
      <PaymentsModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title="Number of Contracts"
        filter={filter}
      />
    </Link>
  );
};

export default TotalActiveSupport;
